<div class="main-div">

    <div></div>

    <div class="main-header">Start this race</div>

    <div class="break"></div>
    
    <div class="main-text"><strong>{{ event_name }}</strong></div>
    <div class="break"></div>

    <div class="main-text">Click on the button below to start the race</div>
    <div class="break"></div>
    <div class="main-div">
        <mat-card class="card2" (click)="start_race()">
<div class="icon-container">
          <mat-icon aria-hidden="false" aria-label="Scan the QR code" class="mat-icon-style">alarm</mat-icon>
        </div>
          <div class="break"></div>
        Start race
        </mat-card>
      </div>
        <div class="break"></div>
        <div class="spacer"></div>
</div>
<app-mat-spinner-overlay overlay="true" *ngIf="loading">
</app-mat-spinner-overlay>
